import { useDispatch, useSelector } from 'react-redux';
import { FileInput, Select } from '@mantine/core';
import Papa from 'papaparse';
import {
  selectedSpeciesModelSelector,
  setLoadingMessage,
  setSelectedSpeciesModel,
  setShowGlobalLoading,
  speciesModelOptionsSelector,
} from '../../../store/slices/appSlice';
import { useState } from 'react';
import { NotificationType, showNotification } from '../../../utils/showNotifications';
import { validateHeaders } from '../helpers';
import {
  NotificationOptionTypes,
  setMissingFields,
  setNotificationModalOpen,
  setNotificationType,
} from '../../../store/slices/adminSlice';
import store from '../../../store/store';
import { requiredFields } from '../../../config/adminRequiredHeaders.config';
import { updateSpeciesDataModel } from '../../../services/aws';
import WFIDButton from '../../../components/WFIDButton/WFIDButton';

let fileData = null as any;
const validateFile = (file: File) => {
  const hashMapFields = new Map<string, string>();

  if (file) {
    Papa.parse(file, {
      complete: (result) => {
        result.meta.fields?.forEach((field) => {
          hashMapFields.set(field, field);
        });
        if (result.errors?.length) {
          console.error('Error parsing file', result.errors);

          return false;
        }
        const missingFields = validateHeaders(requiredFields, hashMapFields);

        if (missingFields.length) {
          // show error message
          store.dispatch(setMissingFields(missingFields));
          store.dispatch(setNotificationModalOpen(true));
          store.dispatch(setNotificationType(NotificationOptionTypes.MissingHeaders));
        } else {
          fileData = result.data;
        }
      },
      header: true,
      skipEmptyLines: true,
    });
  }
};

const DataModelsComponent = () => {
  const selectedSpeciesModel = useSelector(selectedSpeciesModelSelector);
  const speciesModelOptions = useSelector(speciesModelOptionsSelector);
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedSpeciesOption, setSelectedSpeciesOption] = useState<any | null>();
  const dispatch = useDispatch();

  const handleSpeciesChange = (value: string | null, options: any) => {
    dispatch(setSelectedSpeciesModel(value));
    setSelectedSpeciesOption(options);
  };
  const handleFileChange = (value: File | null) => {
    setFile(value);

    if (value) {
      const selectedSpecie = `${selectedSpeciesOption?.value}.${selectedSpeciesOption?.fileExtension}`;
      if (selectedSpecie !== value.name) {
        // show warning message
        showNotification({
          type: NotificationType.Warning,
          message: 'Please make sure you are uploading the correct file',
          title: 'Name Mismatch',
        });
      }
      validateFile(value);
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    dispatch(setShowGlobalLoading(true));
    dispatch(setLoadingMessage('Updating...'));
    const body = {
      body: JSON.stringify({
        fileName: selectedSpeciesOption.originalFileName,
        newContent: fileData,
      }),
    };
    if (fileData?.length) {
      const response = await updateSpeciesDataModel(body);
      if (!response?.success) {
        // show error message
        setLoading(false);
        showNotification({
          type: NotificationType.Error,
          title: 'Error',
          message: 'There was an error, please try again',
        });
        dispatch(setNotificationModalOpen(true));
        dispatch(setShowGlobalLoading(false));

        dispatch(setLoadingMessage(''));
        return;
      }
      showNotification({
        type: NotificationType.Success,
        title: 'Success',
        message: `"${selectedSpeciesOption.value}" data model updated successfully`,
      });
      dispatch(setShowGlobalLoading(false));
      dispatch(setLoadingMessage(''));

      setFile(null);
      dispatch(setSelectedSpeciesModel(null));
      setSelectedSpeciesOption(null);
      setLoading(false);
      fileData = null;
    }
  };
  return (
    <div className='admin-content-container'>
      <div>
        <Select
          w='300px'
          searchable
          value={selectedSpeciesModel}
          label='Select species'
          disabled={loading}
          onChange={handleSpeciesChange}
          placeholder='Select species'
          data={speciesModelOptions}
          clearable
        />
      </div>

      {!!selectedSpeciesModel && (
        <div className='input-file-wrapper'>
          <FileInput
            placeholder='Choose file'
            className='file-upload'
            value={file}
            withAsterisk
            disabled={loading}
            color='red'
            variant='deafult'
            clearable
            size='md'
            w={200}
            accept='.csv'
            onChange={handleFileChange}
          />
        </div>
      )}

      {!!selectedSpeciesModel && !!file && (
        <div className='admin-buttons-container'>
          <WFIDButton disabled={loading} bgColor='white' content='Update' onClick={handleUpdate} />
        </div>
      )}
    </div>
  );
};

export default DataModelsComponent;
